module.exports = __webpack_public_path__ + "img/dbzx.1826d2e2.jpg";